import axios from 'axios'

const ENDPOINTS = {
    'ADD': '/cart/add.js',
    'CART': '/cart.js',
    'CHANGE': '/cart/change.js',
    'PRODUCT': '/products/[REPLACE].js',
    'UPDATE': '/cart/update.js'
}

class AjaxCart {
    static async addItem (payload) {
        let cart = await this.getCart()
        let product = null
        product = await axios.post(`${ENDPOINTS.ADD}?cache=${this._rand()}`, payload)
        cart = await this.getCart()
        const event = new CustomEvent('cartItemAdded', { detail: cart })
        if (cart.status === 200) document.dispatchEvent(event)
        return {
            'cart': cart,
            'product': product
        }
    }

    static async getProduct (handle) {
        let product = await axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', handle)}?cache=${this._rand()}`)
        return product
    }

    static async changeItem (payload) {
        payload.id = `${payload.id}`
        let cart = await axios.post(`${ENDPOINTS.CHANGE}?cache=${this._rand()}`, payload)
        cart.data.line_count = this.getLineCount(cart.data)
        return cart
    }
    static async changeAttribute (payload) {
        let cart = await axios.post(`${ENDPOINTS.UPDATE}?cache=${this._rand()}`, payload)
        return cart
    }
    static async updateItems (payload) {
        payload = {
            'updates': payload
        }
        let cart = await axios.post(`${ENDPOINTS.UPDATE}?cache=${this._rand()}`, payload)
        return cart
    }

    static async getCart () {
        return axios.get(`${ENDPOINTS.CART}?cache=${this._rand()}`)
    }

    static async removeItem (id) {
        let payload = {
            'id': `${id}`,
            'quantity': 0
        }
        let product = await axios.post(`${ENDPOINTS.CHANGE}?cache=${this._rand()}`, payload)
        let cart = await axios.get(`${ENDPOINTS.CART}?cache=${this._rand()}`)

        cart.data.line_count = this.getLineCount(cart.data)
        return {
            'cart': cart,
            'product': product
        }
    }

    static getLineCount (cart) {
        return cart.items.length
    }

    static _rand () {
        return Math.floor(100000000 + Math.random() * 900000000)
    }
}

export default AjaxCart



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/AjaxCart.js